import React from 'react';
import { useState, useEffect } from 'react';
import Header from './Header';
import { gameState, initGame, insertGameKey, insertPlayerOption, Options, gameData, 
  cancel, acceptGame, resultGame, lastGameState, claimGame, 
  GameData} from './Web3Service';


function App() {
  const [message, setMessage] = useState("");
  const [gameKey, setGameKey] = useState("0000000000000000000000000000000000000000000000000000000000000000");

  const [playerOption, setPlayerOption] = useState(Number);
  //const [gameDataThis, setGameDataThis] = useState<GameData>(gameData);

  // Deep copy to avoid referencing the same memory location
  const [gameDataThis, setGameDataThis] = useState<GameData>({
      ...gameData, // Spread the properties of gameData
    });

  const [lastP1, setLastP1] = useState("");
  const [lastOddness, setLastOddness] = useState("");
  const [lastP2, setLastP2] = useState("");
  const [shildButton, setShildButton] = useState(false);

  useEffect(()=>{  
    gameState()
      .then(state => {
        setGameDataThis(state);
        lastGameStateThis();
      })
      .catch(err => setMessage(err.message));
  }, []);
  
  function onInputGameKey(event: React.ChangeEvent<HTMLInputElement>){
      setGameKey(event.target.value);
  }

  function onInputPlayerOption(event: React.ChangeEvent<HTMLInputElement>){
    setPlayerOption(Number(event.target.value));
  }

  function refreshMetaMaskApp(){
    gameState()
    .then(state => {
      setGameDataThis(state);
      lastGameStateThis();
      console.log("Refresh");
    })
    .catch(err => setMessage(err.message));
  }
  
  function onChangeGameKey(){

    const hexRegex = /^[0-9a-fA-F]+$/; // Matches valid hex strings starting with '0x'

    console.log('GameKey: ', gameKey);
    if(gameKey.length != 64){
      setMessage("Only 64 hex string accepted.");
    }
    else if (!hexRegex.test(gameKey)) {
      setMessage("Invalid game key: Must be a valid 64 hex string.");
    }
    else{  
      
      if(!shildButton){
        setShildButton(true);
        insertGameKey(gameKey)
          .then(tx => {
            setMessage(tx);
            setShildButton(false);
          })
          .catch(err => {
            setMessage(err.message);
            setShildButton(false);
          });

      }
    }
  }

  function onChangeP1Option(){

    if(playerOption < 0 || playerOption > 10){
      setMessage("Only numbers form 0 to 10 are accepted.");
    }
    else{
      
      if(!shildButton){
        setShildButton(true);
        insertPlayerOption(playerOption, true)
          .then(option => {
            setMessage(String(option));
            setShildButton(false);
          })
          .catch(err => {
            setMessage(err.message);
            setShildButton(false);
          });
      }
    }
  }

  function onChangeP2Option(){
    
    if(playerOption < 0 || playerOption > 10){
      setMessage("Only numbers form 0 to 10 are accepted.");
    }
    else{
      
      if(!shildButton){
        setShildButton(true);
        insertPlayerOption(playerOption, false)
          .then(option => {
            setMessage(String(option));
            setShildButton(false);  
          })
          .catch(err => {
            setMessage(err.message);
            setShildButton(false);
          });  
      }
    }
  }

  function onPlay(option: Options){
    setMessage("");
    console.log("shildButton 0: ", shildButton);
    if(!shildButton){
      setShildButton(true);
      console.log("shildButton 1: ", shildButton);
      initGame(option == 1 ? true: false)
        .then(state => {
          setGameDataThis({
            ...state, // Spread the properties of state
          });
          setShildButton(false);
        })
        .catch(err => {
          setMessage(err.message);
          setShildButton(false);
        });
    }
  }

  function onCancel(){
    setMessage("");
    
    if(!shildButton){
      setShildButton(true);
      cancel()
        .then(state => {
          setGameDataThis({
            ...state, // Spread the properties of state
          });
          lastGameStateThis();
          setShildButton(false);
        })
        .catch(err => {
          setMessage(err.message);
          setShildButton(false);
        });
    }
  }

  function onAccept(){
    setMessage("");
    
    if(!shildButton){
      setShildButton(true);
      acceptGame()
        .then(state => {
          setGameDataThis({
            ...state, // Spread the properties of state
          });
          setShildButton(false);
        })
        .catch(err => {
          setMessage(err.message);
          setShildButton(false);
        });
    }
  }

  function onResult(){
    setMessage("");
    
    if(!shildButton){
      setShildButton(true);
      resultGame()
        .then(state => {
          setGameDataThis({
            ...state, // Spread the properties of state
          });
          lastGameStateThis();
          setShildButton(false);
        })
        .catch(err => {
          setMessage(err.message);
          setShildButton(false);
        });
    }
  }

  function onClaim(){
    setMessage("");
    
    if(!shildButton){
      setShildButton(true);
      claimGame()
      .then(state => {
        setGameDataThis({
          ...state, // Spread the properties of state
        });
        lastGameStateThis();
        setShildButton(false);
      })
      .catch(err => {
        setMessage(err.message);
        setShildButton(false);
      });
    }
  }

  function lastGameStateThis(){

    lastGameState()
    .then(state => {
      setLastP1("#P1 = " + String(state.optionP1));
      setLastP2("#P2 = " + String(state.optionP2));
      let oddness = state.isOdd? "Odd": "Even"
      setLastOddness("Oddness P1 = " + oddness);
    })
    .catch(err => setMessage(err.message));
  }

  return (
    <div className='container'>
        <Header />
        <main>
          <div className='py-0 text-center'>

            <img className='d-block mx-auto mb-2' src='./logo512.png' alt='OddOrEven' width={72}/>
            <h3> Odd or Even </h3>
            <p className='lead'> Play the game. </p>
          </div>
          <div className='col-md-8 col-lg-12'>
            <div className='row'>

              <div className='py-0 col-sm-6'>
                <div className='col-sm-12'> 
                  <label htmlFor='gamekey' className='form-label'> Player 1 Game Key (hex):</label>
                  <div className='input-group'>
                    <input type='hex' className='form-control' id='gamekey' 
                            style={{ fontSize: '12px' }} 
                            value={gameKey || ""}
                            maxLength={64} 
                            onChange={onInputGameKey}/>
                    <span className='input-group-text bg-secondary' style={{ fontSize: '12px' }} >hex</span>
                    <button type='button' className='btn btn-primary d-inline-flex align-items-center' style={{ fontSize: '12px' }}  onClick={onChangeGameKey}>Insert</button>

                  </div>
                </div>
                <div className='py-5 col-sm-12'> 
                  <label htmlFor='playerOption' className='form-label'> Player Option (0 to 10):</label>
                  <div className='input-group'>
                    <input type='number' className='form-control' id='gamekey'style={{ fontSize: '12px' }}  value={playerOption || 0} onChange={onInputPlayerOption}/>
                    <span className='input-group-text bg-secondary' style={{ fontSize: '12px' }} >num</span>
                    {
                      gameDataThis.hashOptionP1 == "0x0000000000000000000000000000000000000000000000000000000000000000"  ?
                      <button type='button' className='btn btn-primary d-inline-flex align-items-center' style={{ fontSize: '12px' }} onClick={onChangeP1Option}>Insert</button>
                      :
                      gameDataThis.optionP2 == -1?
                      //gameDataThis.player2 == "0x0000000000000000000000000000000000000000"?
                      <button type='button' className='btn btn-primary d-inline-flex align-items-center' style={{ fontSize: '12px' }} onClick={onChangeP2Option}>Insert</button>
                      :
                      <button type='button' className='btn btn-primary d-inline-flex align-items-center'style={{ fontSize: '12px' }}  onClick={onChangeP1Option}>Insert</button>
                    }
                  </div>
                </div>

                <div className='col-sm-12'> 
                  <label htmlFor='gamekey' className='form-label'> Last Game Result </label>
                  <div className='input-group'>
                    <input type='text' className='form-control text-center' style={{ fontSize: '12px' }}  id='gamekey' value={lastOddness || ""}/>
                    <input type='text' className='form-control text-center' style={{ fontSize: '12px' }}  id='gamekey' value={lastP1 || ""}/>
                    <input type='text' className='form-control text-center' style={{ fontSize: '12px' }}  id='gamekey' value={lastP2 || ""}/>
                    <button type='button' className='btn btn-primary d-inline-flex align-items-center'style={{ fontSize: '12px' }}  onClick={refreshMetaMaskApp}>Refresh</button>
                    
                  </div>
                </div>

              </div>
              <div className='col-sm-6'>
                <h5 className='mb-2'>Game</h5>
                <div className='card card-body border-0 shadow'>
                  <h5 className='mb-2 text-primary'>
                    {  gameDataThis.hashOptionP1 == "0x0000000000000000000000000000000000000000000000000000000000000000"  ? 
                      "Initialize Game:"
                      :
                      gameDataThis.optionP2 == -1?
                      //gameDataThis.player2 == "0x0000000000000000000000000000000000000000"?
                      "Hash Player 1:"
                      :
                      "Player 2 Option"
                    }
                    </h5>
                  <div className='alert alert-success' style={{ fontSize: '12px' }}>
                    {
                      //"Loading ..."
                      gameDataThis.hashOptionP1 == "0x0000000000000000000000000000000000000000000000000000000000000000"  ? 
                      "Insert Game Key and Number Choice:"
                      :
                      gameDataThis.optionP2 == -1?
                      //gameDataThis.player2 == "0x0000000000000000000000000000000000000000"?
                      gameDataThis.hashOptionP1
                      :
                      gameDataThis.optionP2
                    }
                  </div>
                  <h5 className='mb-2 text-primary'>
                    {
                      //leaderboard && leaderboard.result?.indexOf("won") !== -1 || !leaderboard?.result
                      //? "Start a new game:"
                      //:
                      gameDataThis.hashOptionP1 == "0x0000000000000000000000000000000000000000000000000000000000000000"  ? 
                      "Choose Odd or Even:"
                      :
                      gameDataThis.optionP2 == -1?
                      //gameDataThis.player2 == "0x0000000000000000000000000000000000000000"?
                      "Accept or Quit Game"
                      :
                      "Result or Claim Game"
                    }
                  </h5>
                    {
                      gameDataThis.hashOptionP1 == "0x0000000000000000000000000000000000000000000000000000000000000000"  ?
                      <div className='d-flex'>
                        <div className='col-sm-6'>
                          <div className='alert alert-info me-3 play-button' onClick={() => onPlay(Options.ODD)}>
                            <img src='/assets/odd.png' width={100} alt='Odd'/>
                          </div>
                        </div>
                        <div className='col-sm-6'>
                          <div className='alert alert-info ms-3 play-button' onClick={() => onPlay(Options.EVEN)}>
                            <img src='/assets/even.png' width={100} alt='Even'/>
                          </div>
                        </div>
                      </div>
                      :
                      gameDataThis.optionP2 == -1?
                      //gameDataThis.player2 == "0x0000000000000000000000000000000000000000"?
                      <div className='d-flex'>
                        <div className='col-sm-6'>
                          <div className='alert alert-info me-3 play-button' onClick={() => onAccept()}>
                            <img src='/assets/play.png' width={100} alt='Play'/>
                          </div>
                        </div>
                        <div className='col-sm-6'>
                          <div className='alert alert-info ms-3 play-button' onClick={() => onCancel()}>
                            <img src='/assets/cancel.png' width={100} alt='Cancel'/>
                          </div>
                        </div>
                      </div>
                      :
                      <div className='d-flex'>
                        <div className='col-sm-6'>
                          <div className='alert alert-info me-3 play-button' onClick={() => onResult()}>
                            <img src='/assets/play.png' width={100} alt='Play'/>
                          </div>
                        </div>
                        <div className='col-sm-6'>
                          <div className='alert alert-info ms-3 play-button' onClick={() => onClaim()}>
                            <img src='/assets/cancel.png' width={100} alt='Cancel'/>
                          </div>
                        </div>
                      </div>

                    }
                </div>
                
              </div>

            </div>

          </div>
          <div className='py-3 text-center'>
            <p className='lead text-danger'> {message} </p>
          </div>
          
        </main>
    </div>
  );
}

export default App;


/*
import React from 'react';
import Header from './Header';

function App() {
  return (
    <div className="container">
      <Header />
      <main>
        App Page
      </main>
    </div>
  );
}

export default App;

*/